import { baseConfig, IMG_BASE, CDN_DOMAIN } from '@com/core/common/baseConfig';
import { TRegionAPI, TRegionSEO, TLocaleAPI, TLanguage } from '@com/core/common/types/locale';
import { TMarketplaceConfig } from '@com/core/common/types/config';
import { TI18nOptions } from '@com/core/common/types/webconfig';

const marketplaceConfig: TMarketplaceConfig = {
    ...baseConfig,
    regions: {
        ...baseConfig.regions,
        ae: {
            ...baseConfig.regions.ae,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: '800-38888',
        },
        sa: {
            ...baseConfig.regions.sa,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: '800-1160210',
        },
        eg: {
            ...baseConfig.regions.eg,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'egypt@noon.com',
            supportPhone: '16358',
        },
    },
    urls: {
        ...baseConfig.urls,
        appStore: 'https://itunes.apple.com/app/noon-%D9%86%D9%88%D9%86/id1269038866?ls=1&mt=8',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.noon.buyerapp',
        facebook: '',
        twitter: '',
        instagram: '',
        linkedin: '',
        supportInfo: {
            careers: 'https://www.linkedin.com/company/nooncom/jobs/',
            partners: `https://login.noon.partners/en/register`,
        },
    },
    assets: {
        ...baseConfig.assets,
        icons: {
            ...baseConfig.assets.icons,
            shipmentMethod: {
                dd: `${IMG_BASE}/noon/icons/shipment_method_dd.svg`,
                sc: `${IMG_BASE}/noon/icons/shipment_method_sc.svg`,
                sdd: `${IMG_BASE}/noon/icons/shipment_method_sdd.svg`,
                fallback: `${IMG_BASE}/noon/icons/shipment_method_fallback.svg`,
            },
            favicon: `${IMG_BASE}/noon/icons/favicon.ico`,
            cartBlue: '',
            cartBlack: '',
            wishListBlack: '',
            wishList: '',
            shipment: `${IMG_BASE}/noon/icons/shipment.svg`,
            address: `${IMG_BASE}/noon/icons/account_addresses.svg`,
            cart: `${IMG_BASE}/noon/icons/cart.svg`,
            checkboxChecked: `${IMG_BASE}/noon/icons/checkbox_checked.svg`,
            checkboxUnchecked: `${IMG_BASE}/noon/icons/checkbox_unchecked.svg`,
            claims: `${IMG_BASE}/noon/icons/account_claims.svg`,
            preferences: `${IMG_BASE}/noon/icons/account_preferences.svg`,
            collectionPointsToggle: `${IMG_BASE}/noon/icons/locker_switch.svg`,
            credits: `${IMG_BASE}/noon/icons/account_credits.svg`,
            edit: `${IMG_BASE}/noon/icons/edit.svg`,
            globe: `${IMG_BASE}/noon/icons/globe.svg`,
            hamburger: `${IMG_BASE}/noon/icons/hamburger.svg`,
            home: `${IMG_BASE}/noon/icons/home.svg`,
            magnifyingGlass: `${IMG_BASE}/noon/icons/magnifying_glass.svg`,
            orders: `${IMG_BASE}/noon/icons/account_orders.svg`,
            payments: `${IMG_BASE}/noon/icons/account_payments.svg`,
            profile: `${IMG_BASE}/noon/icons/account_profile.svg`,
            returns: `${IMG_BASE}/noon/icons/account_returns.svg`,
            shop: `${IMG_BASE}/noon/icons/shop.svg`,
            signOut: `${IMG_BASE}/noon/icons/sign_out.svg`,
            trash: `${IMG_BASE}/noon/icons/trash.svg`,
            user: `${IMG_BASE}/noon/icons/user.svg`,
        },
        images: {
            ...baseConfig.assets.images,
            addressesEmptySlate: `${IMG_BASE}/noon/images/account/addresses-empty.svg`,
            addressCollectionIndicator: `${IMG_BASE}/noon/images/address_collection_indicator.svg`,
            addressLatLngIndicator: `${IMG_BASE}/noon/images/address_latlng_indicator.svg`,
            paymentEmptySlate: `${IMG_BASE}/noon/images/account/payment-empty.svg`,
            cartEmpty: '',
            claimsEmptySlate: `${IMG_BASE}/noon/images/account/claims-empty.svg`,
            claimsSuccessSlate: `${IMG_BASE}/noon/images/account/claims-success.svg`,
            claimsTypeChecked: `${IMG_BASE}/noon/images/account/claim_type_checked.svg`,
            claimsTypeUnchecked: `${IMG_BASE}/noon/images/account/claim_type_unchecked.svg`,
            claimsTypeDamage: `${IMG_BASE}/noon/images/account/claim_damage_warranty.svg`,
            claimsTypeProtection: `${IMG_BASE}/noon/images/account/claim_protection.svg`,
            defaultMap: `${IMG_BASE}/noon/images/address_defualt_map.png`,
            defaultProductPlaceholder: `${CDN_DOMAIN}/nr/misc/product-image-default.jpg`,
            error404: `${IMG_BASE}/noon/images/error-404.svg`,
            fulfilmentExpressAr: `${IMG_BASE}/noon/images/fulfilment_express-ar.png`,
            fulfilmentExpressEn: `${IMG_BASE}/noon/images/fulfilment_express-en.png`,
            fulfilmentPreOrderAr: `${IMG_BASE}/noon/images/fulfilment_preorder-ar.svg`,
            fulfilmentPreOrderEn: `${IMG_BASE}/noon/images/fulfilment_preorder-en.svg`,
            logoBG: `${IMG_BASE}/noon/images/noon-logo-bg.svg`,
            mapCollectionPointPickup: `${IMG_BASE}/noon/images/map_collection-point-pickup.svg`,
            mapCollectionPointLocker: `${IMG_BASE}/noon/images/map_collection-point-locker.svg`,
            mapCollectionPointToggle: `${IMG_BASE}/noon/images/map_collection-point-locker.svg`,
            mapLocateMeEn: `${IMG_BASE}/noon/images/map_locateme_en.svg`,
            mapLocateMeAr: `${IMG_BASE}/noon/images/map_locateme_ar.svg`,
            mapLandmarkPin: `${IMG_BASE}/noon/images/map_landmark-pin.svg`,
            returnsEmptyState: `${IMG_BASE}/noon/images/account/returns-empty.svg`,
            secure: '',
            returnablesEmptyState: `${IMG_BASE}/noon/images/account/returnables-empty.svg`,
            returnSuccess: `${IMG_BASE}/noon/images/account/returns-success.svg`,
            transferRequestSuccess: `${IMG_BASE}/noon/images/account/transfer_success.svg`,
            bankTransferEmpty: `${IMG_BASE}/noon/images/account/bank_transfer_empty.svg`,
            chevronRight: `${IMG_BASE}/noon/images/chevron_right.svg`,
            chevronRightWhite: `${IMG_BASE}/noon/images/chevron_right_white.svg`,
            loyalty: {
                bulletCheck: `${IMG_BASE}/noon/images/loyalty/vip-bullet-check.svg`,
                bulletStar: `${IMG_BASE}/noon/images/loyalty/vip-bullet-star.svg`,
                vipAR: `${IMG_BASE}/noon/images/loyalty/vip_en.svg?v=2`,
                vipEN: `${IMG_BASE}/noon/images/loyalty/vip_en.svg?v=2`,
                tick: `${IMG_BASE}/noon/images/loyalty/tick.svg`,
            },
        },
    },
    headerSupportBar: false,
    gtm: {
        ...baseConfig.gtm,
        gtmID: 'GTM-N6VX7WB',
        gaID: process.env.ENV === 'prod' ? 'UA-84507530-14' : 'UA-84507530-4',
        optimizeID: 'OPT-TLXWQP6',
    },
    enabledFeatures: {
        loyalty: true,
    },
};

export default marketplaceConfig;

// Computed Locale Configurations
export const SEO_REGIONS = Object.keys(baseConfig.regions).map(
    (region: string) => baseConfig.regions[region as TRegionAPI].seo,
);
const seoLocalesArr = SEO_REGIONS.map(
    (seoRegion: TRegionSEO) =>
        baseConfig.languages.map((language: TLanguage) => `${seoRegion}-${language}` as TLocaleAPI) as TLocaleAPI[],
);
export const SEO_LOCALES = [].concat(...(seoLocalesArr as [])) as TLocaleAPI[];
export const API_REGIONS = Object.keys(baseConfig.regions);

// Common i18n config (server, client)
export const i18nOptions: TI18nOptions = {
    lowerCaseLng: true,
    defaultLanguage: SEO_LOCALES[0],
    otherLanguages: [...SEO_LOCALES, ...baseConfig.extrai18nLocales],
    ignoreRoutes: ['/_next', '/static', '/_svc', '/hc'],
    whitelist: SEO_LOCALES,
};
